export enum Role {
  Admin = 100,
  Editor = 200,
  Viewer = 300,
}

export enum RoleText {
  Admin = 'admin',
  Editor = 'editor',
  Viewer = 'viewer',
}
